import { Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";

export type LatestUpdateTextProps = {
    updatedWhen: string;
}

const LatestUpdateText = ({updatedWhen}: LatestUpdateTextProps) => {
    const intl = useIntl();

    const getUpdatedWhenText = (updatedWhen: string) => {
        const projectUpdated = new Date(updatedWhen);
        const today = new Date();
        let daysSinceUpdate = Math.round((today.getTime() - projectUpdated.getTime())/(1000 * 3600 * 24));
      
        if (daysSinceUpdate === 0) {
            return intl.formatMessage({id:"general.updatedWhen.today", defaultMessage: "Today"});
        } else if (daysSinceUpdate === 1) {
            return  intl.formatMessage({id:"general.updatedWhen.oneDayAgo", defaultMessage: "1 day ago"});
        } else if (daysSinceUpdate > 0 && daysSinceUpdate < 7) {
          return  intl.formatMessage({id:"general.updatedWhen.XDaysAgo", defaultMessage: "{numberOfDays} days ago"}, {numberOfDays: daysSinceUpdate});
        } else if (daysSinceUpdate >= 7 && daysSinceUpdate < 14) {
          return  intl.formatMessage({id:"general.updatedWhen.oneWeekAgo", defaultMessage: "1 week ago"});
        } else {
          return  intl.formatMessage({id:"general.updatedWhen.XWeeksAgo", defaultMessage: "{numberOfWeeks} weeks ago"}, {numberOfWeeks: Math.round(daysSinceUpdate/7)});
        }
      }

    return (
        <Typography tag="span" textAlign="right" variant="Body1" text={getUpdatedWhenText(updatedWhen)} />
    );
};

export default LatestUpdateText;